import React, { useEffect, useState } from 'react';
import { Button, Col, Form, Input, message, Row, Select, Switch } from 'antd';
import {SFuncModal} from "shj-components";
import {ticketsRepairsReplay} from "@/services/customerServices.ts";

const { TextArea } = Input;

const ModifyModalDom = (props: { onClose: () => void; fn?: () => void; [key: string]: any }) => {
  const { onClose, fn, record } = props;
  const id = record?.id;
  const [form] = Form.useForm();
  const { setFieldsValue } = form;
  const [submitLoading, setSubmitLoading] = useState<boolean>(false);
  const [data, setData] = useState<any>({});

  const isEdit = () => !!(record && record.id);
  const updateData = (newData: Record<string, any>) => {
    setData(newData);
    setFieldsValue(newData);
  };

  const initFn = () => {
    updateData({});
  };

  useEffect(() => {
    initFn();
  }, []);

  // 提交
  const onFinish = () => {
  form.validateFields().then(values => {
    const requestData = { ...values, ...data };
    setSubmitLoading(true);
    if (isEdit()) {
      requestData.id = id;
    }
    ticketsRepairsReplay(requestData)
      .then((resp: any) => {
        message.success(resp?.message || '操作成功');
        onClose && onClose();
        fn && fn();
      })
      .finally(() => {
        setSubmitLoading(false);
      });
  })
  };
  const onChange = (val: Record<string, any>) => {
    setData({
      ...data,
      ...val,
    });
  };

  return (
    <SFuncModal.Content
      confirmLoading={submitLoading}
      onCancel={onClose}
      onOk={onFinish}
    >
      <Form
        form={form}
        autoComplete="off"
        onValuesChange={onChange}
        labelAlign={'right'}
        labelCol={{ span: 4 }}
        layout='vertical'
      >
        <Row gutter={12}>
          <Col span={24}>
            <Form.Item label="回复：" name="replyContent" rules={[{ required: true, message: '不能为空' }]}>
              <TextArea placeholder="请输入" rows={4} maxLength={300} showCount/>
            </Form.Item>
          </Col>
        </Row>
      </Form>
    </SFuncModal.Content>
  );
};

export function modifyModal(props: any) {
  const { fn, title, ...otherProps } = props;
  let dialog: any = 0;
  const onClose = () => {
    (dialog as any)?.destroy();
  };
  dialog = SFuncModal({
    width: 600,
    title: `${title}`,
    vanish: true,
    content: <ModifyModalDom onClose={onClose} fn={fn} {...otherProps} />,
  });

  return dialog;
}
